export const dateFormat = 'DD.MM.YYYY'
export const validDays = [1, 15]